import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import CategoryPage from "../pages/category/page";
import ProductPage from "../pages/product/page";
import ContactPage from "../pages/contact/page";
import AboutPage from "../pages/about/page";
import FAQPage from "../pages/faq/page";
import QuotePage from "../pages/quote/page";
import LegalPage from "../pages/legal/page";
import TrackOrderPage from "../pages/track/page";
import SourcingCasePage from "../pages/sourcing-case/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/products/:slug", element: <CategoryPage /> },
  { path: "/products/item/:slug", element: <ProductPage /> },
  { path: "/contact", element: <ContactPage /> },
  { path: "/about", element: <AboutPage /> },
  { path: "/faq", element: <FAQPage /> },
  { path: "/quote", element: <QuotePage /> },
  { path: "/legal", element: <LegalPage /> },
  { path: "/track", element: <TrackOrderPage /> },
  { path: "/sourcing-case", element: <SourcingCasePage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
